export default __webpack_public_path__ + "static/cooperHero-846d3828d5fdfcfb5e88022c37cf1af1.jpg";